module.exports = __webpack_public_path__ + "img/trusted.e55e5085.jpeg";